class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const itemKey = this.dataset.key;
      if (!itemKey) {
        console.warn('[CartRemoveButton] No data-key found. Cannot remove item.');
        return;
      }
      this.closest('cart-items').updateQuantityByKey(itemKey, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value, 10), 0);
    this.debouncedOnChange = this.debounce((event) => this.onChange(event), 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target && event.target.matches('[name="updates[]"]')) {
      const newQty = parseInt(event.target.value, 10) || 0;
      const itemKey = event.target.dataset.key;
      if (!itemKey) {
        console.warn('[CartItems] No data-key on quantity input. Cannot update item.');
        return;
      }
      this.updateQuantityByKey(itemKey, newQty);
    }
  }

  updateQuantityByKey(itemKey, quantity) {
    // Check if item is locked
    const item = this.querySelector(`[data-key="${itemKey}"]`);
    if (item && item.dataset.locked === 'true') {
      console.log('[CartItems] Item is locked, cannot modify');
      this.disableLoading();
      return;
    }

    this.enableLoading(itemKey);
    const bodyData = {
      id: itemKey,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify(bodyData),
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.status === 422) {
          console.warn('[CartItems] 422 Error:', parsedState);
          this.disableLoading();
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const container = document.getElementById(section.id).querySelector(section.selector) ||
                           document.getElementById(section.id);
          container.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        });

        this.updateLiveRegions(quantity);
        this.disableLoading();
      })
      .catch((err) => {
        console.error('[CartItems] Update failed:', err);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML || '';
  }

  enableLoading(itemKey) {
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');
    document.activeElement.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');
  }

  updateLiveRegions(quantity) {
    this.currentItemCount = quantity;
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', true);
    }
    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
    }
  }

  debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }
}

customElements.define('cart-items', CartItems);